export const inputSizes = {
  xl: 450,
  l: 350,
  m: 200,
  s: 150,
} as const;

export type InputSize = keyof typeof inputSizes;
